export const TRANSLATIONS_PT = {
  welcome:"Bem vindo ao tutorial",
 };